<template>
  <v-navigation-drawer
    scrim="transparent"
    location="right"
    temporary
    width="400"
  >
    <v-fab
      :icon="mdiClose"
      absolute
      class="ma-2"
      location="left top"
      size="large"
      @click="$emit('close')"
    />

    <v-container fluid>
      <v-row>
        <v-col>
          <v-lazy>
            <ReviewsBody />
          </v-lazy>
        </v-col>
      </v-row>
    </v-container>
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import { mdiClose } from '@mdi/js'

defineEmits(['close'])
</script>
